import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const HubHomePage = lazyWithChunkReload(() => import("./pages/homepage").then((m) => ({ default: m.Homepage })));

export const HubAcademyPage = lazyWithChunkReload(() =>
  import("./pages/academy/academy").then((m) => ({ default: m.Academy }))
);

export const HubContributionPage = lazyWithChunkReload(() =>
  import("./pages/contribution/contribution").then((m) => ({ default: m.Contribution }))
);

export const HubSolutionSbtiPage = lazyWithChunkReload(() =>
  import("./pages/solutions/sbti").then((m) => ({ default: m.SbtiSolution }))
);

export const HubSolutionEmpcoPage = lazyWithChunkReload(() =>
  import("./pages/solutions/empco").then((m) => ({ default: m.EmpcoSolution }))
);

export const HubSolutionScope3Page = lazyWithChunkReload(() =>
  import("./pages/solutions/scope-3").then((m) => ({ default: m.Scope3Solution }))
);

/**
 * The homepage sits behind three nested lazy boundaries (providers, page, dashboard), which would
 * otherwise download one after another. Failures are left to the lazy components, which retry.
 */
export const preloadHubHomePage = (isEmployeeInternal: boolean): void => {
  const ignore = () => undefined;
  import("./homescreen-providers").catch(ignore);
  import("./pages/homepage").catch(ignore);
  (isEmployeeInternal ? import("./pages/cm-dashboard/cm-dashboard") : import("./pages/customer-homepage")).catch(
    ignore
  );
};
